import { useQuery, useMutation, } from "@tanstack/react-query";
export const createOrdersQueries = (requests, queryClient) => ({
    useListOrders: (params, options = {}) => useQuery({
        queryKey: ["orders", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listOrders(params);
        },
        ...options,
    }),
    useFindOrder: (params, options = {}) => useQuery({
        queryKey: ["order", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findOrder(params);
        },
        ...options,
    }),
    useDownloadOrderProforma: (options = {}) => useMutation({
        mutationFn: (payload) => {
            return requests.downloadOrderProforma(payload);
        },
        onSuccess: (data) => {
            options.onSuccess?.(data, null, null);
        },
    }),
    useGetOrderCost: (params, options = {}) => useQuery({
        queryKey: ["orderCost", params.id, params.discount_code_id ?? null],
        queryFn: async () => {
            const response = await requests.getOrderCost(params);
            return response.data;
        },
        ...options,
    }),
    useDownloadOrdersReport: (options = {}) => useMutation({
        mutationFn: (payload) => {
            return requests.downloadOrdersReport(payload);
        },
        onSuccess: (data) => {
            options.onSuccess?.(data, null, null);
        },
    }),
    useRemoveOrderItem: (options = {}) => useMutation({
        mutationFn: (payload) => {
            return requests.removeOrderItem(payload);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["orders"] });
            queryClient.invalidateQueries({ queryKey: ["order"] });
            queryClient.invalidateQueries({ queryKey: ["orderCost"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map